import React, { useState, useEffect } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Button, Col, Alert } from '@themesberg/react-bootstrap';
// import { saveAs } from 'file-saver';
import { get, post } from '../../services/back.service';
import ModalMessage from '../../components/widgets/modalMessage';
// import { basetoblob } from '../../utils/functions';
import SearchFormInspect from '../../components/widgets/formSearch';
import ModalFormAuthInspect from '../../components/forms/inspection/form.authorizationInspect';
import DownloadButton from '../../components/widgets/downloadButton';
// import DirectionPathButton from '../../components/widgets/directionPathButton';
import { FaFilePdf, FaImages, FaFileAlt } from 'react-icons/fa';
import { Spinner } from '@themesberg/react-bootstrap';

function InspectionReport() {
  const [infoReport, setInfoReport] = useState([]);
  const [showModalPdf, setShowModalPdf] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({});
  const [selectInspect, setSelectInspect] = useState(0);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });
  const [loadingAudit, setLoadingAudit] = useState(null);

  const modalState = (row) => {
    return (
      <ModalFormAuthInspect
        title="Gestionar Autorizacion"
        button_text="Gestionar"
        button_variant="outline-primary"
        inspectionSelect={row}
        callback={createScore}
      ></ModalFormAuthInspect>
    );
  };

  const createScore = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    searching(currentFilter);
  };

  const downloadImages = async (row) => {
    const respo = await get('/peritaje/downloadimages/' + row.id);
    if (respo.success) {
      const element = document.createElement("a");
      element.href = respo.data.presigned_url;
      element.click();
      element.remove()
    } else {
      setAlert({
        show: true,
        message: respo.message,
        type: 'danger',
      });
    }
  }



  const downloadAudit = async (row) => {
    setLoadingAudit(row.id);
    const respo = await get(`/peritaje/audit/inspection/${row.id}/pdf/`);
    if (respo.success) {
      const element = document.createElement("a");
      element.href = respo.data.urlFile;
      element.click();
      element.remove()
      searching(currentFilter);
    } else {
      setAlert({
        show: true,
        message: respo.message,
        type: 'danger',
      });
    }
    setLoadingAudit(null);
    setShowModalPdf(false);
  };

  const editButton = (row) => {
    return (
      <div>
        <Col>
          {modalState(row)}
          <Button className='m-1'
            disabled={!(row.state === 'A' || row.state === 'AP')}
            onClick={() => {
              setAlert({ show: false });
              setShowModalPdf(true);
              setSelectInspect(row.id);
            }}
            variant="outline-primary"
            title='Ver PDF'
          >
            <FaFilePdf />
          </Button>
          <Button className='m-1'
            onClick={() => downloadImages(row)}
            variant="outline-primary"
            title='Ver Imagenes'
          >
            <FaImages />
          </Button>
          <Button className='m-1'
            onClick={() => downloadAudit(row)}
            variant="outline-primary"
            title='Descargar Auditoria'
            disabled={loadingAudit === row.id}
          >
            {loadingAudit === row.id ? <Spinner animation="border" size="sm" /> : <FaFileAlt />}
          </Button>
        </Col>
      </div>
    );
  };


  const searching = async (data) => {
    setCurrentFilter(data);
    const body = data
    const respoReport = await post('/peritaje/inspectionreportauth/', body);
    if (respoReport.success) {
      setInfoReport(respoReport.data);
    } else {
      console.log(respoReport);
    }
  };

  useEffect(() => { }, []);

  // Call the function with the desired key as a parameter to download the file


  const generatePdf = async () => {
    const respo = await get('/peritaje/viewpdf/' + selectInspect);
    if (respo.success) {
      const element = document.createElement("a");
      element.href = respo.data.urlFile;
      element.click();
      element.remove()
      searching(currentFilter);
    } else {
      setAlert({
        show: true,
        message: respo.message,
        type: 'danger',
      });
    }
    setShowModalPdf(false);
  };

  return (
    <Base>
      {alert.show && (
        <Alert
          variant={alert.type}
          onClose={() => setAlert({ show: false })}
          dismissible
        >
          {alert.message}
        </Alert>
      )}
      <ModalMessage
        title={'Advertencia'}
        text={`Desea generar el pdf del peritaje No ${selectInspect}?`}
        showProps={showModalPdf}
        funcAccept={generatePdf}
        funcClose={() => setShowModalPdf(false)}
      />
      <SearchFormInspect searching={searching} />
      <DownloadButton infoReport={infoReport} filename={'peritajes.csv'} separator={';'} />
      <ListTables
        data={infoReport}
        editar={editButton}
        messageWd="sin peritajes en el filtro"
        headerAlwaysShow={true}
        hideFirst={true}
      />
    </Base>
  );
}

export default InspectionReport;
